import React from 'react';
import { IconButton, Tooltip, TextField, Paper } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import RoofingIcon from '@mui/icons-material/Roofing';
import ParkIcon from '@mui/icons-material/Park';
import OilBarrelIcon from '@mui/icons-material/OilBarrel';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useMapContext } from '../Map/MapContext';
import { Button } from '@mui/material';
import { useState } from 'react';

import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';


const AddLIDPanel = () => {

    const { 
        inpFile,
        userData,
        LIDType, 
        setLIDType,
        devPlanID,
        devPlanContent,
        setDevPlanContent,
        selectedStormOption,
        handleCloseLIDPanel,
        selectedFeature,
        planHasBeenRun,
    } = useMapContext();

    const selectedFeatureData = selectedFeature.Data;

    const lidTypeMapping = {
        RG1: "Rain Garden",
        Planter: "Tree Planter",
        GR1: "Green Roof",
        RB12: "Rain Barrel"
    };

    const [selectedLID, setSelectedLID] = useState(null);
    const [quantity, setQuantity] = useState('');
    const [area, setArea] = useState('');
    const [volume, setVolume] = useState('');

    const [openErrorDialog, setOpenErrorDialog] = useState(false);


    const handleLIDClick = (type) => {
        setLIDType(type);
    };

    const getLIDTypeName = (lidType) => {
        return lidTypeMapping[lidType];
    };

    const handleQuantityChange = (event) => {
        setQuantity(event.target.value);
    };

    const handleAreaChange = (event) => {
        setArea(event.target.value);
    };

    const handleVolumeChange = (event) => {
        setVolume(event.target.value);
    };

    const handleAddClick = () => {
        if (quantity && LIDType && selectedFeatureData && inpFile) {
            let adjusted_area = 0;
    
            if (LIDType === 'RG1' || LIDType === 'GR1') { 
                adjusted_area = parseFloat(area).toFixed(2);
            } else if (LIDType === 'RB12') { 
                adjusted_area = ((volume * 0.133681) / 3).toFixed(2);
            } else { 
                adjusted_area = 9; 
            }

            if (quantity <= 0) {
                setOpenErrorDialog(true);
                setQuantity('');
                setArea('');
                setVolume('');
                return;
            }

            if ((LIDType === 'RB12' && volume <= 0) || (LIDType === 'RG1' && area <= 0) || (LIDType === 'GR1' && area <= 0)) {
                setOpenErrorDialog(true);
                setQuantity('');
                setArea('');
                setVolume('');
                return; 
            }
    
            const lid = {
                'subcatch_id': selectedFeatureData.NAME, 
                'lid_name': LIDType, 
                'n_replicate': parseInt(quantity), 
                'area': parseFloat(adjusted_area)
            };
            const user = {
                'user_id': userData.id, 
                'dev_plan': devPlanID
            };

            if (!inpFile) {
                console.error('No input file selected');
                return;
            }

            const base_model = `GLWA_${selectedStormOption}`;

            const requestData = {
                base_model: base_model,
                user: user,
                lid: lid
            };

            console.log("The requestData is: ", requestData);

            fetch('https://2471d2z813.execute-api.us-east-2.amazonaws.com/add-lid', {
                method: 'POST',
                headers: {'Content-Type': 'application/json',},
                body: JSON.stringify(requestData)
            })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
                setDevPlanContent(prevContent => ({
                    ...prevContent,
                    [selectedFeatureData.NAME]: {
                        ...prevContent[selectedFeatureData.NAME],
                        [LIDType]: { n_replicate: parseInt(quantity), area: parseFloat(adjusted_area) }
                    }
                }));
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    
            setArea('');
            setVolume('');
            setQuantity('');
            setLIDType('');
        }
    };

    const handleDeleteLIDRow = (lidType, subcatchmentName, adjusted_area) => {
        console.log(`Trying to delete ${lidType} in ${subcatchmentName}`);

        if (inpFile && userData && userData.id && devPlanID && selectedStormOption) {
    
            const lid = {
                'subcatch_id': subcatchmentName, 
                'lid_name': lidType, 
                'n_replicate': 0, 
                'area': adjusted_area
            };
            const user = { 'user_id': userData.id, 'dev_plan': devPlanID };
            const base_model = `GLWA_${selectedStormOption}`;
            const requestData = { base_model: base_model, user: user, lid: lid };

            console.log("The requestData is: ", requestData);

            fetch('https://2471d2z813.execute-api.us-east-2.amazonaws.com/add-lid', {
                method: 'POST',
                headers: {'Content-Type': 'application/json',},
                body: JSON.stringify(requestData)
            })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
                setDevPlanContent(prevContent => {
                    const updatedContent = { ...prevContent };
                    if (updatedContent[subcatchmentName] && updatedContent[subcatchmentName][lidType]) {
                        delete updatedContent[subcatchmentName][lidType];
                    }
                    return updatedContent;
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    
            setArea('');
            setVolume('');
            setQuantity('');
            setLIDType('');
        } else if (!inpFile) {
            console.error('No inp file associated');
        } else if (!selectedStormOption) {
            console.error('No storm option selected');
        } else {
            console.error('Cannot delete LID row: something is missing');
        }
    };

    const renderLIDRow = (lidType, lidData, subcatchmentName) => {
        if (lidData.n_replicate > 0) {
            const getIcon = (type) => {
                switch(type) {
                    case 'RG1': return <LocalFloristIcon />;
                    case 'GR1': return <RoofingIcon />;
                    case 'Planter': return <ParkIcon />;
                    case 'RB12': return <OilBarrelIcon />;
                    default: return null;
                }
            };

            return (
                <div key={`${lidType}-${subcatchmentName}`} style={{ marginBottom: '5px' }}>
                    <Button
                        onClick={() => setSelectedLID(selectedLID === `${lidType}-${subcatchmentName}` ? null : `${lidType}-${subcatchmentName}`)}
                        fullWidth
                        style={{
                            justifyContent: 'flex-start',
                            textTransform: 'none',
                            color: '#94cfec',
                            padding: '5px 10px',
                            backgroundColor: selectedLID === `${lidType}-${subcatchmentName}` ? '#2a3a42' : 'transparent',
                            '&:hover': {
                                backgroundColor: '#2a3a42',
                            },
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <div style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                                {getIcon(lidType)}
                                <span style={{ marginLeft: '15px', fontSize: '14px' }}>
                                    {lidType === 'RB12' 
                                        ? `${((lidData.area * 3) / 0.133681).toFixed(0)} G (${lidData.n_replicate} count)`
                                        : `${lidData.area} sq ft. (${lidData.n_replicate} count)`
                                    }
                                    {/* {lidData.area} sq ft. ({lidData.n_replicate} count) */}
                                </span>
                            </div>
                            {selectedLID === `${lidType}-${subcatchmentName}` && (
                                <IconButton
                                    size="small"
                                    style={{
                                        color: '#94cfec',
                                        padding: '4px',
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteLIDRow(lidType, subcatchmentName, lidData.area);
                                    }}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            )}
                        </div>
                    </Button>
                </div>
            );
        }
        return null;
    };

    if (planHasBeenRun) {
        return null;
    }

    return (
        <div>
            <Dialog 
                open={openErrorDialog} 
                onClose={() => setOpenErrorDialog(false)}
                PaperProps={{
                    style: {
                        backgroundColor: '#1e2a30',
                        color: '#94cfec',
                    }
                }}
            >
                <DialogTitle>Invalid Quantity</DialogTitle>
                <DialogContent>
                    You can't add negative green infrastructure...
                </DialogContent>
                <DialogActions>
                    <Button 
                        onClick={() => setOpenErrorDialog(false)}
                        style={{ color: '#94cfec' }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        
        <div
            style={{
                position: 'absolute',
                bottom: 20,
                left: 50,
                width: '700px',
                height: '250px',
                backgroundColor: '#071317',
                opacity: 0.9,
                zIndex: 10,
                borderRadius: '5px',
                padding: '10px',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <IconButton
                style={{ position: 'absolute', top: 0, right: 0, zIndex: 20 }}
                onClick={handleCloseLIDPanel}
            >
                <CloseIcon style={{ color: '#94cfec' }} fontSize="small" />
            </IconButton>

            <h4 style={{ color: '#94cfec', textAlign: 'left', margin: '5px 0px 0px 10px' }} >
                Add Green Infrastructure to {selectedFeatureData.NAME}
            </h4>

            {/* Three-column container */}
            <div style={{ display: 'flex', flex: 1, width: '100%' }}>
                {/* First column: Type selection */}
                <div style={{ flex: 1, display: 'grid', gridTemplateRows: 'auto 1fr', padding: '10px', gap: '10px' }}>
                    <h5 style={{ color: '#94cfec', margin: '0 0 0 0' }}> Type: <span style={{ color: 'white' }}>{getLIDTypeName(LIDType)}</span> </h5>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                        <Tooltip title="Rain Garden">
                            <IconButton
                                sx={{
                                    backgroundColor: LIDType === 'RG1' ? '#444' : '#1e2a30',
                                    '&:hover': { backgroundColor: '#2a3a42' },
                                    color: '#94cfec',
                                    borderRadius: '8px',
                                    padding: '10px',
                                }}
                                onClick={() => handleLIDClick('RG1')}
                            >
                                <LocalFloristIcon sx={{ fontSize: 40 }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Green Roof">
                            <IconButton
                                sx={{
                                    backgroundColor: LIDType === 'GR1' ? '#444' : '#1e2a30',
                                    '&:hover': { backgroundColor: '#2a3a42' },
                                    color: '#94cfec',
                                    borderRadius: '8px',
                                    padding: '10px',
                                }}
                                onClick={() => handleLIDClick('GR1')}
                            >
                                <RoofingIcon sx={{ fontSize: 40 }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Tree Planter">
                            <IconButton
                                sx={{
                                    backgroundColor: LIDType === 'Planter' ? '#444' : '#1e2a30',
                                    '&:hover': { backgroundColor: '#2a3a42' },
                                    color: '#94cfec',
                                    borderRadius: '8px',
                                    padding: '10px',
                                }}
                                onClick={() => handleLIDClick('Planter')}
                            >
                                <ParkIcon sx={{ fontSize: 40 }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Rain Barrel">
                            <IconButton
                                sx={{
                                    backgroundColor: LIDType === 'RB12' ? '#444' : '#1e2a30',
                                    '&:hover': { backgroundColor: '#2a3a42' },
                                    color: '#94cfec',
                                    borderRadius: '8px',
                                    padding: '10px',
                                }}
                                onClick={() => handleLIDClick('RB12')}
                            >
                                <OilBarrelIcon sx={{ fontSize: 40 }} />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>

                {/* Second column: Amount inputs */}
                <div style={{ flex: 1, padding: '10px', color: '#94cfec' }}>
                    <h5 style={{ color: '#94cfec', margin: '0 0 15px 0' }}> Amount: </h5>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        <TextField
                            variant="outlined"
                            type="number"
                            label="Quantity"
                            value={quantity}
                            onChange={handleQuantityChange}
                            InputLabelProps={{
                                style: { 
                                    color: '#94cfec',
                                    top: '-5px', 
                                    fontSize: '14px'
                                },
                            }}
                            InputProps={{style: {color: '#94cfec', backgroundColor: '#1e2a30', borderRadius: '5px', height: '40px', padding: '0 5px'}}}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': { borderColor: '#94cfec', },
                                    '&:hover fieldset': { borderColor: '#94cfec', },
                                    '&.Mui-focused fieldset': { borderColor: '#94cfec', },
                                },
                                width: '100%',
                            }}
                        />
                        {(LIDType === 'RG1' || LIDType === 'GR1') && (
                            <TextField
                                variant="outlined"
                                type="number"
                                label="Area (sq ft)"
                                value={area}
                                onChange={handleAreaChange}
                                InputLabelProps={{
                                    style: { 
                                        color: '#94cfec',
                                        top: '-5px', 
                                        fontSize: '14px'
                                    },
                                }}
                                InputProps={{style: {color: '#94cfec', backgroundColor: '#1e2a30', borderRadius: '5px', height: '40px', padding: '0 5px'}}}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': { borderColor: '#94cfec', },
                                        '&:hover fieldset': { borderColor: '#94cfec', },
                                        '&.Mui-focused fieldset': { borderColor: '#94cfec', },
                                    },
                                    width: '100%',
                                }}
                            />
                        )}
                        {LIDType === 'RB12' && (
                            <TextField
                                variant="outlined"
                                type="number"
                                label="Volume (gallons)"
                                value={volume}
                                onChange={handleVolumeChange}
                                InputLabelProps={{
                                    style: { 
                                        color: '#94cfec',
                                        top: '-5px', 
                                        fontSize: '14px' 
                                    },
                                }}
                                InputProps={{style: {color: '#94cfec', backgroundColor: '#1e2a30', borderRadius: '5px', height: '40px', padding: '0 5px'}}}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': { borderColor: '#94cfec', },
                                        '&:hover fieldset': { borderColor: '#94cfec', },
                                        '&.Mui-focused fieldset': { borderColor: '#94cfec', },
                                    },
                                    width: '100%',
                                }}
                            />
                        )}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                            <IconButton
                                variant="contained"
                                style={{
                                    backgroundColor: '#2a3a42',
                                    color: '#94cfec',
                                    borderRadius: '5px',
                                }}
                                onClick={handleAddClick}
                            >
                                <AddIcon />
                            </IconButton>
                        </div>
                    </div>
                </div>

                {/* Third column: Development Plan summary */}
                <div style={{ flex: 1, padding: '10px', color: '#94cfec' }}>
                    <h5 style={{ color: '#94cfec', margin: '0 0 0 0' }}> Development Plan: </h5>
                    <Paper elevation={3} style={{ 
                        padding: '10px', 
                        backgroundColor: '#1e2a30', 
                        color: '#94cfec', 
                        fontSize: '12px', 
                        maxHeight: '90%', 
                        minHeight: '90%',
                        overflow: 'auto' 
                    }}>
                        {devPlanContent && devPlanContent[selectedFeatureData.NAME] && 
                            Object.entries(devPlanContent[selectedFeatureData.NAME]).map(([lidType, lidData]) => 
                                renderLIDRow(lidType, lidData, selectedFeatureData.NAME)
                            )
                        }
                    </Paper>
                </div>
            </div>
        </div>
        </div>
    );
};

export default AddLIDPanel;